import { FunctionComponent } from 'react'
import { SpecialOfferContent } from '@/services/cms-api/home-page-content/types'
import RichText from './RichText'
import { useLanguage } from '@/context/LanguageContext'
import classNames from 'classnames'
import Image from 'next/image'
import { resolveImageUrl } from '@/utils/constants'

interface Prop {
  content: SpecialOfferContent
  textColor?: string
}

const NewsContentRenderer: FunctionComponent<Prop> = ({ content, textColor }) => {
  const { locale } = useLanguage()

  if (content.__component === 'main.paragraph') {
    return (
      <div className='2xl:w-[680px] xl:w-[650px] lg:w-[600px] md:w-[560px]'>
        <span className={classNames(textColor, 'lg:text-xl font-bold text-textHigh')}>{locale === 'en' ? content.titleEn ?? content.titleMn ?? '' : content.titleMn ?? ''}</span>
        {(content.bodyTextMn !== null && content.bodyTextMn !== undefined) && (
          <RichText textColor={textColor} content={locale === 'en' ? content.bodyTextEn ?? content.bodyTextMn ?? '' : content.bodyTextMn ?? ''} />
        )}
      </div>
    )
  } else {
    return (
      content.image !== undefined && content.image !== null
        ? (
          <Image
            className={classNames('rounded-xl 2xl:w-[784px] xl:w-[750px] lg:w-[716px] md:w-[682px] w-[90vw]', (content.isFreeSize !== true ? 'aspect-[2/1]' : ''))}
            draggable={false}
            width={1000}
            height={1000}
            alt='img'
            src={resolveImageUrl(content.image)}
          />
          )
        : <></>
    )
  }
}
export default NewsContentRenderer
